import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import RangeDatePicker from './RangeDatePicker';
import MessagesContext from '../../../contexts/messagesContext';
import SelectFormType from './SelectFormType';
import moment from 'moment-jalaali';
import { convertFarsiDigitToEnglish } from '../../../utils/converter';
import { DateObject } from 'react-multi-date-picker';
import { useDispatch, useSelector } from 'react-redux';
import { getNamespace } from '../../../utils/storage';
import { todayOrLastWeek } from '../../../utils/dateTimeUtil';
import {
    getFormStatistics,
    getPatientStatistics
} from '../../../redux/Statistics/StatisticsAction';

const styles = makeStyles({
    container: {
        marginBottom: '36px'
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        display: 'flex',
        alignItems: 'center'
    },
    quantity: {
        minWidth: '200px',
        height: '40px',
        marginInlineStart: '15px',
        color: 'black',
        // padding: '8px',
        borderRadius: '4px',
        border: '1.5px solid #ced2d6',
        display: 'flex',
        '& > div': {
            padding: '5px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    quantityTitle: {
        borderInlineEnd: '1px solid #ced2d6',
        width: '60px'
    },
    quantityValue: {
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        '& span:first-child': {
            margin: '0 5px'
        }
    }
});

const pToe = convertFarsiDigitToEnglish;
const StatisticsHeader = ({ title, isFormStatistics = false }) => {
    const classes = styles();
    const patientData = useSelector((state) => state.statistics.patientStatistics);
    const formData = useSelector((state) => state.statistics.formStatistics);
    const statisticsData = isFormStatistics ? formData : patientData;
    const { messages } = useContext(MessagesContext);
    const [formValue, setFormValue] = useState({});
    const dispatch = useDispatch();
    const [value, setValue] = useState([
        new DateObject().setDay(undefined),
        new DateObject().add(1, 'month').setDay(undefined)
    ]);
    const totalStatistics = isFormStatistics ? messages.newForm : messages.newPatient;
    const date = value[0];
    const year = date?.format('YYYY');
    const twoYearsLater = +pToe(year) + 2;
    const month = date?.format('MM');
    const day = date?.format('DD');
    const maxDate = year ? `${twoYearsLater.toString()}/${pToe(month)}/${pToe(day)}` : undefined;
    const startDate = date?.isValid ? moment(new Date(date)).format('YYYY-MM-DD') : undefined;
    const endDate = value[1]?.isValid ? moment(new Date(value[1])).format('YYYY-MM-DD') : undefined;

    useEffect(() => {
        const nameSpace = getNamespace();
        const today = todayOrLastWeek();
        const lastWeek = todayOrLastWeek(true);
        const params = {
            start: startDate ? startDate : lastWeek,
            end: !endDate && !startDate ? today : endDate,
            ...(isFormStatistics && formValue?.id && { form_name: formValue?.id })
        };
        if (params.start && params.end) {
            dispatch(
                isFormStatistics
                    ? getFormStatistics(nameSpace, params)
                    : getPatientStatistics(nameSpace, params)
            );
        }
    }, [isFormStatistics, startDate, endDate, formValue]);

    return (
        <div className={classes.container}>
            <div className={classes.wrapper}>
                <span>{title}</span>
                <div className={classes.row}>
                    <RangeDatePicker maxDate={maxDate} setValue={setValue} value={value} />
                    <div className={classes.quantity}>
                        <div className={classes.quantityTitle}>{messages.total}</div>
                        <div className={classes.quantityValue}>
                            <span>
                                {statisticsData
                                    ?.reduce((acc, cuu) => acc + cuu.count, 0)
                                    .toLocaleString(undefined, {
                                        maximumFractionDigit: 2
                                    })}
                            </span>
                            <span>{totalStatistics}</span>
                        </div>
                    </div>
                </div>
            </div>
            {isFormStatistics ? (
                <SelectFormType setFormValue={setFormValue} formValue={formValue} />
            ) : null}
        </div>
    );
};
StatisticsHeader.propTypes = {
    title: PropTypes.string,
    isFormStatistics: PropTypes.bool
};

export default StatisticsHeader;
